import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

/**
 * Copies the shop's live Local Storefront URL to the clipboard (NEA-5765).
 */
export function CopyStorefrontButton({ url }) {
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		if (!url) return;
		try {
			await navigator.clipboard.writeText(url);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch {
			/* clipboard unavailable — no-op */
		}
	};

	return (
		<button
			type="button"
			onClick={handleCopy}
			disabled={!url}
			className="inline-flex items-center justify-center gap-1.5 rounded-full border border-border bg-white px-4 py-2 text-sm font-semibold text-foreground transition hover:bg-accent disabled:opacity-50"
		>
			{copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
			{copied ? 'Copied' : 'Copy my Storefront link'}
		</button>
	);
}
